var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccessBtnIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 18,
    viewBox: "0 0 11 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0607 3.06066C10.6464 2.47487 10.6464 1.52513 10.0607 0.93934C9.47487 0.353553 8.52513 0.353553 7.93934 0.93934L10.0607 3.06066ZM0.93934 14.9393C0.353553 15.5251 0.353553 16.4749 0.93934 17.0607C1.52513 17.6464 2.47487 17.6464 3.06066 17.0607L0.93934 14.9393ZM7.29289 10.7071L6.23223 9.64645L7.29289 10.7071ZM7.93934 0.93934L2.64644 6.23223L4.76777 8.35355L10.0607 3.06066L7.93934 0.93934ZM4.41421 10.5H6.58579V7.5H4.41421V10.5ZM6.23223 9.64645L0.93934 14.9393L3.06066 17.0607L8.35355 11.7678L6.23223 9.64645ZM6.58579 10.5C6.14033 10.5 5.91725 9.96143 6.23223 9.64645L8.35355 11.7678C9.92847 10.1929 8.81305 7.5 6.58579 7.5V10.5ZM2.64644 6.23223C1.07153 7.80715 2.18696 10.5 4.41421 10.5V7.5C4.85966 7.5 5.08275 8.03857 4.76777 8.35355L2.64644 6.23223Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessBtnIcon);
export default __webpack_public_path__ + "static/media/SuccessBtnIcon.c68b872f3ab752d51356d14502909dae.svg";
export { ForwardRef as ReactComponent };